import { HttpContextToken } from '@angular/common/http';

// Default is false (uses Ming Client API).
// Set to true ONLY when you need the Admin API (e.g., Registration).
export const USE_ADMIN_API = new HttpContextToken<boolean>(() => false);
export const USE_OTP_API = new HttpContextToken<boolean>(() => false);
export const SUPPRESS_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
